import { Component, Input, OnInit } from '@angular/core';
import * as d3 from 'd3';
@Component({
  selector: 'app-grouped-bar-chart',
  templateUrl: './grouped-bar-chart.component.html',
  styleUrls: ['./grouped-bar-chart.component.scss'],
})
export class GroupedBarChartComponent implements OnInit {
  constructor() {}
  @Input() name!: string;
  @Input() data: any;
  @Input() columns: any;
  @Input() public colors: any;
  @Input() legends: any;

  ngOnInit(): void {}
  ngAfterViewInit(): void {
    const margin = { top: 10, right: 30, bottom: 40, left: 50 },
      width = 570 - margin.left - margin.right,
      height = 220 - margin.top - margin.bottom;

    // append the svg object to the body of the page
    const svg = d3
      .select(`#${this.name}`)
      .append('svg')
      .attr('width', width + margin.left + margin.right)
      .attr('height', height + margin.top + margin.bottom)
      .attr(
        'viewBox',
        `0,0, ${width + margin.left + margin.right},${
          height + margin.top + margin.bottom
        }`
      )
      .append('g')
      .attr('transform', 'translate(' + margin.left + ',' + margin.top + ')');

    // Define the gradient
    const gradient = svg
      .append('defs')
      .append('linearGradient')
      .attr('id', 'bar-gradient2')
      .attr('x1', '0%')
      .attr('y1', '0%')
      .attr('x2', '100%')
      .attr('y2', '0%');

    gradient.append('stop').attr('offset', '70%').attr('stop-color', '#fff'); // Start color

    gradient.append('stop').attr('offset', '71%').attr('stop-color', '#000'); // End color

    // Define the pattern
    const pattern = svg
      .append('defs')
      .append('pattern')
      .attr('id', 'white-bar-pattern')
      .attr('width', '4')
      .attr('height', '4')
      .attr('patternUnits', 'userSpaceOnUse')
      .attr('patternTransform', 'rotate(90)');

    pattern
      .append('rect')
      .attr('width', '4')
      .attr('height', '4')
      .attr('fill', 'url(#bar-gradient2)');

    // List of subgroups = header of the csv files = soil condition here
    const subgroups = this.columns.slice(1);
    // List of groups = species here = value of the first column called group -> I show them on the X axis
    const groups: any = d3.map(this.data, function (d: any) {
      return d.group;
    });

    // Add X axis
    let x: any = d3.scaleBand().domain(groups).range([0, width]).padding(0.2);
    svg
      .append('g')
      .attr('transform', `translate(0,${height})`)
      // .attr('transform', 'translate(0,' + height + ')')
      .call(d3.axisBottom(x).tickSize(0));

    // Add Y axis
    let maxValue =
      d3.max(this.data, (d: any) =>
        Math.max(d.field1, d.field2, d.field3 ? d.field3 : 0)
      ) || 100;
    let _this = this;
    let y = d3.scaleLinear().domain([0, maxValue]).range([height, 0]);
    svg.append('g').call(
      d3.axisLeft(y).tickFormat(function (d) {
        return _this.name !== 'hiringAttrition' ? d + '%' : d + '';
      })
    );

    // Another scale for subgroup position?
    let xSubgroup: any = d3
      .scaleBand()
      .domain(subgroups)
      .range([0, x.bandwidth()])
      .padding(0.05);
    // color palette = one color per subgroup
    let color: any = d3.scaleOrdinal().domain(subgroups).range(this.colors);

    // Show the bars
    svg
      .append('g')
      .selectAll('g')
      // Enter in data = loop group per group
      .data(this.data)
      .enter()
      .append('g')
      .attr('transform', function (d: any) {
        return 'translate(' + x(d.group) + ',0)';
      })
      .selectAll('rect')
      .data(function (d: any) {
        return subgroups.map(function (key: any) {
          return { key: key, value: d[key] };
        });
      })
      .enter()
      .append('rect')
      .attr('x', (d: any) => xSubgroup(d.key))
      .attr('y', function (d: any) {
        return y(d.value);
      })
      .attr('width', xSubgroup.bandwidth())
      .attr('height', function (d: any) {
        return height - y(d.value);
      })
      .attr('fill', (d: any) => color(d.key));

    var legend = svg
      .append('g')
      .attr('class', 'legend')
      .attr('height', 100)
      .attr('width', 100)
      .attr('transform', 'translate(-5,' + (height + 35) + ')');
    const colors = this.colors;
    const legends = this.legends;
    legend
      .selectAll('rect')
      .data(this.legends)
      .enter()
      .append('rect')
      .attr('x', function (d, i) {
        var xPost = legendXPosition(legends, i, 6);
        return xPost;
      })
      .attr('y', -10)
      .attr('width', 15)
      .attr('height', 5)
      .style('fill', function (d, i) {
        var color = colors[i];
        return color;
      });

    legend
      .selectAll('text')
      .data(this.legends)
      .enter()
      .append('text')
      .attr('x', function (d, i) {
        if (legends) var xPost = legendXPositionText(legends, i, 17, 6);
        return xPost;
      })
      .attr('y', -1)
      .text((d: any) => d);

    function legendXPositionText(
      data: any,
      position: any,
      textOffset: any,
      avgFontWidth: any
    ) {
      return legendXPosition(data, position, avgFontWidth) + textOffset;
    }
    function legendXPosition(data: any, position: any, avgFontWidth: any) {
      if (position == 0) {
        return 0;
      } else {
        var xPostiion = 0;
        for (var i = 0; i < position; i++) {
          xPostiion += data[i].length * avgFontWidth + 40;
        }
        return xPostiion;
      }
    }
  }
}
